export default "__VITE_ASSET__pdFGl4rF__";